import React from 'react';
import {
  FEATURE_PILLARS,
  PREPARATION_FLOW,
  USE_CASES,
} from '../config/productCopy';

/** Compact Upload → Prepare → Use strip (signed-in upload surface) */
export const PreparationWorkflow: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`w-full ${className}`}>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
      {PREPARATION_FLOW.map((item) => (
        <div
          key={item.step}
          className="rounded-lg border border-slate-200 bg-slate-50 p-4"
        >
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Step {item.step}
          </p>
          <h3 className="mt-1 text-base font-semibold text-slate-800">{item.title}</h3>
          <p className="mt-1 text-sm text-slate-600">{item.description}</p>
        </div>
      ))}
    </div>
  </div>
);

/** Use cases + feature pillars for marketing surface above pricing */
export const PositioningSections: React.FC = () => (
  <div className="mt-12 space-y-12">
    <section>
      <h2 className="text-2xl font-bold text-center text-slate-900 dark:text-white">
        Built for real educational workflows
      </h2>
      <p className="mt-2 text-center text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
        Designed to help educators prepare documents before AI tools, training, or collaboration — when
        appropriate for your context.
      </p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {USE_CASES.map((item) => (
          <div
            key={item.title}
            className="rounded-lg border border-slate-200 dark:border-slate-700 p-5 bg-white dark:bg-slate-800"
          >
            <h3 className="font-semibold text-slate-800 dark:text-slate-100">{item.title}</h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{item.description}</p>
          </div>
        ))}
      </div>
    </section>

    <section>
      <h2 className="text-2xl font-bold text-center text-slate-900 dark:text-white">
        What preparation includes today
      </h2>
      <p className="mt-2 text-center text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
        Redaction is the core capability now — with room to grow into a fuller preparation layer over time.
      </p>
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURE_PILLARS.map((item) => (
          <div
            key={item.title}
            className="rounded-lg border border-slate-200 dark:border-slate-700 p-5 bg-white dark:bg-slate-800"
          >
            <h3 className="font-semibold text-slate-800 dark:text-slate-100">{item.title}</h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);
